import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/third_party/font_awesome.min.js';
import { RichEditComponent } from './rich-edit.component';

@NgModule({
  declarations: [RichEditComponent],
  imports: [CommonModule, FroalaEditorModule.forRoot(), FroalaViewModule.forRoot()],
  exports: [RichEditComponent]
})
export class RichEditModule {}
